import type { ReactNode } from 'react';

export const symbol_code_xml: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m139-480 122 123q9 9 9 21t-9 21q-9 9-21 9t-21-9L75-459q-9-9-9-21t9-21l144-144q9-9 21-9t21 9q9 9 9 21.5t-9 21.5L139-480Zm226 295.5q-6-10.5-2-22.5l177-564q4-12 14.5-18t22.5-2q12 4 18 15t2 23L421-189q-4 12-15 17.5t-23 1.5q-12-4-18-14.5ZM821-480 699-603q-9-9-9-21t9-21q9-9 21-9t21 9l144 144q9 9 9 21t-9 21L741-315q-9 9-21 9t-21-9q-9-9-9-21.5t9-21.5l122-122Z"
		/>
	</svg>
);
